import { FormTextField, FormTextFieldProps } from './FormTextField';

export type PasswordFieldProps = FormTextFieldProps;

export function PasswordField({ autoComplete = 'current-password', ...props }: PasswordFieldProps) {
  const isNew = autoComplete === 'new-password';

  return (
    <FormTextField
      type="password"
      autoComplete={autoComplete}
      minLength={isNew ? 8 : undefined}
      maxLength={isNew ? 100 : undefined}
      inputProps={isNew ? { minLength: 8, maxLength: 100 } : undefined}
      {...props}
    />
  );
}
